import { definePlugin, defineAIActions } from '@kernel/core/plugin-loader';

// AI 动作定义
const aiActions = defineAIActions({
  namespace: 'account',
  actions: [
    {
      id: 'query',
      name: '查询账号',
      description: '根据条件搜索和筛选账号',
      parameters: [
        { name: 'keyword', type: 'string', description: '搜索关键词' },
        { name: 'status', type: 'string', description: '账号状态', required: false },
        { name: 'trackId', type: 'number', description: '赛道ID', required: false },
      ],
      handler: async (params) => {
        // 调用 API 查询账号
        const response = await fetch(`/api/v1/accounts?${new URLSearchParams(params as Record<string, string>)}`);
        const data = await response.json();
        return {
          type: 'table',
          data: data.data,
          message: `找到 ${data.data?.length || 0} 个账号`,
        };
      },
    },
    {
      id: 'analyze',
      name: '分析账号',
      description: '深度分析账号健康度和表现',
      parameters: [
        { name: 'accountId', type: 'number', description: '账号ID', required: true },
      ],
      handler: async (params) => {
        const response = await fetch(`/api/v1/accounts/${params.accountId}/analyze`);
        const data = await response.json();
        return {
          type: 'report',
          data: data.data,
          message: '账号分析完成',
        };
      },
    },
    {
      id: 'batch-update',
      name: '批量更新账号',
      description: '批量修改账号属性或状态',
      confirm: true,
      parameters: [
        { name: 'accountIds', type: 'array', description: '账号ID列表', required: true },
        { name: 'updates', type: 'object', description: '更新内容', required: true },
      ],
      handler: async (params) => {
        const response = await fetch('/api/v1/accounts/batch', {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(params),
        });
        const data = await response.json();
        return {
          type: 'action',
          data: data.data,
          message: `成功更新 ${params.accountIds?.length || 0} 个账号`,
        };
      },
    },
  ],
});

// 导出插件定义
export default definePlugin({
  meta: {
    name: 'account-manager',
    version: '1.0.0',
    displayName: '账号管理',
    description: '小红书账号的添加、分组、监控和生命周期管理',
    icon: 'users',
    category: 'core',
  },

  // 生命周期钩子
  onLoad: async () => {
    console.log('[Plugin] Account Manager loaded');
  },

  onUnload: () => {
    console.log('[Plugin] Account Manager unloaded');
  },

  // 路由配置
  routes: [
    {
      path: '/accounts',
      lazy: async () => {
        const { AccountList } = await import('./pages/AccountList');
        return { Component: AccountList };
      },
    },
    {
      path: '/accounts/new',
      lazy: async () => {
        const { AccountNew } = await import('./pages/AccountNew');
        return { Component: AccountNew };
      },
    },
    {
      path: '/accounts/groups',
      lazy: async () => {
        const { AccountGroups } = await import('./pages/AccountGroups');
        return { Component: AccountGroups };
      },
    },
    {
      path: '/accounts/:id',
      lazy: async () => {
        const { AccountDetail } = await import('./pages/AccountDetail');
        return { Component: AccountDetail };
      },
    },
  ],

  // 侧边栏菜单
  sidebarMenus: [
    {
      id: 'accounts',
      title: '账号管理',
      icon: 'users',
      path: '/accounts',
      order: 1,
    },
  ],

  // AI 动作
  aiActions,
});

